import PropTypes from 'prop-types';
import { Chip } from '@mui/material';

export default function GrantExpiryChip({ expiresAt }) {
  return <Chip size="small" color="warning" variant="outlined" label={`Expires ${expiresAt}`} />;
}

GrantExpiryChip.propTypes = {
  expiresAt: PropTypes.string.isRequired,
};
